<template>
  <div class="locations-map">
    <iframe
      id="map"
      title="locations"
      :src="src"
      width="100%"
      style="border:0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'LocationsMap',
  props: {
    src: {
      require: true,
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.locations-map{
  height: auto;
  width: 100%;
  position: relative;
}
.locations-map > iframe {
  min-height: 500px;
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
